module.exports = __webpack_public_path__ + "static/img/Kalani-White.e773002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kalani-White.jpg
// module id = 5rrQ
// module chunks = 0